export type BaseDiscount = {
  amount: number
  type: 'percentage' | 'fixed'
  bundle?: string
  regions?: string[]
  condition?: string | null
}

export type OrderDiscountConfiguration = {
  scope: 'order'
} & BaseDiscount

export type VariableDiscountConfiguration = {
  scope: 'variable'
  // Specific variable to discount ie. 'index', 'coating'
  variable: string
} & BaseDiscount

export type TextDiscount = { scope: 'text'; text: string; label?: string }

export type DiscountConfiguration =
  | OrderDiscountConfiguration
  | VariableDiscountConfiguration
